// extracted by mini-css-extract-plugin
var _1 = "StorageLimitAlert_alertMessage__07fa6";
export { _1 as "alertMessage" }
